import { render, staticRenderFns } from "./LeagueTable.vue?vue&type=template&id=331096f2&"
import script from "./LeagueTable.vue?vue&type=script&lang=js&"
export * from "./LeagueTable.vue?vue&type=script&lang=js&"
import style0 from "./LeagueTable.vue?vue&type=style&index=0&id=331096f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports